/**
* Centered Graphic Box JS
* -----------------------------------------------------------------------------
*
* All the JS for the Centered Graphic Box component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'centered-graphic-box',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const components = document.querySelectorAll( '.centered-graphic-box' );

      if ( !components.length ) return;

      components.forEach( ( component ) => {
        const contentBox = component.querySelector( '.content-box' );
        const graphics = component.querySelectorAll( '.graphic-element' );

        if ( !contentBox || !graphics.length ) return;

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 80%',
            end: 'center 30%',
            scrub: 1,
          },
        } );

        // Set initial position for all graphics (behind content box)
        graphics.forEach( ( graphic ) => {
          // Store original position for animation target
          const computedStyle = window.getComputedStyle( graphic );
          const originalTop = computedStyle.top;
          const originalLeft = computedStyle.left;
          const originalRight = computedStyle.right;
          const originalBottom = computedStyle.bottom;

          // Set initial position (centered behind content box)
          gsap.set( graphic, {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            xPercent: -50,
            yPercent: -50,
            opacity: 0.3,
            scale: 0.7,
            zIndex: 10,
          } );

          tl.to( graphic, {
            top: originalTop,
            left: originalLeft === 'auto' ? 'auto' : originalLeft,
            right: originalRight === 'auto' ? 'auto' : originalRight,
            bottom: originalBottom === 'auto' ? 'auto' : originalBottom,
            xPercent: 0,
            yPercent: 0,
            opacity: 1,
            scale: 1,
            zIndex: 20,
            ease: 'power2.out',
          }, 0 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'centered-graphic-box', COMPONENT );
} )( app );
